var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 699.3504,
    y1: 1001.7012,
    x2: 1317.3915,
    y2: 1001.7012
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 2.543131e-7,
    style: {
      stopColor: "#0000FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#CD00FF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M785.44,533.92c117.75,0,235.53,0,353.28,0c76.69,0,127.61-8.99,160.8,37.68c7.08,9.96,12.34,22.38,15.12,36.48 c3.28,16.66,1.44,38.69,1.44,57.6c0,37.2,0,74.4,0,111.6c0,162.06,0,324.18,0,486.24c0,91.92,13.74,161.92-47.76,196.56 c-22.4,12.61-61.2,9.84-96.48,9.84c-39.68,0-79.36,0-119.04,0c-68.79,0-137.61,0-206.4,0c-49.35,0-84.92,2.84-112.56-18.96 c-41-32.33-33.84-81.01-33.84-151.92c0-108.07,0-216.17,0-324.24c0-89.75,0-179.53,0-269.28c0-43.97-4.72-97.27,11.28-125.52 c11.6-20.48,29.52-36.13,54.48-43.2C772.32,535.84,778.88,534.88,785.44,533.92z M755.44,588.16 c22.06-18.92,71.04-12.96,111.36-12.96c91.35,0,182.73,0,274.08,0c37.22,0,95.59-6.19,116.64,10.32 c24.74,19.4,18.68,63.98,18.48,107.28c-178.62,0-357.3,0-535.92,0C739.94,653.98,734.41,606.2,755.44,588.16z M875.68,618.64 c71.51,0,143.05,0,214.56,0c20.21,0,67.14-7.57,63.84,15.36c-0.74,5.16-3.81,9.28-8.16,10.8c-19.68,0.16-39.36,0.32-59.04,0.48 c-70.31,0-140.65,0-210.96,0C861.47,642.49,863.91,623.43,875.68,618.64z M1276,723.76c0,190.62,0,381.3,0,571.92 c-178.62,0-357.3,0-535.92,0c0-190.62,0-381.3,0-571.92C918.7,723.76,1097.38,723.76,1276,723.76z M1276,1326.64 c0.16,36.86,3.51,73.27-16.32,90c-21.26,17.93-71.67,12.24-110.4,12.24c-91.27,0-182.57,0-273.84,0c-36.28,0-94.96,6.05-115.92-9.6 c-24-17.92-19.66-51.48-19.44-92.64C918.7,1326.64,1097.38,1326.64,1276,1326.64z M1004.08,1341.76 c51.49-0.92,52.74,69.31,7.2,75.12c-38.71,4.94-50.68-46.89-26.64-66.72C990.14,1345.62,995.97,1344.02,1004.08,1341.76z  M825.28,1363.84c12-0.19,48.11-3.03,55.68,1.44c4.33,2.56,6,6.64,6,13.68c-0.32,3.6-0.64,7.2-0.96,10.8 c-1.24,2.86-4.51,5.83-7.68,6.72c-8.55,2.41-54.71,1.01-58.8-2.16c-4.4-3.41-4.71-9.45-4.56-17.52 C815.11,1368.88,819.26,1365.95,825.28,1363.84z M1146.16,1363.84c21.97-0.34,61.9-7.38,61.92,14.88c-0.4,3.76-0.8,7.52-1.2,11.28 c-1.34,2.86-4.41,5.57-7.68,6.48c-8.13,2.27-54.36,1.07-58.32-1.92c-4.73-3.57-4.84-9.24-4.8-17.76 C1136.12,1368.8,1140.2,1365.93,1146.16,1363.84z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.aedb28c493f94a55e0d234d29b810f5e.svg";
export { ForwardRef as ReactComponent };